"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembersTable = void 0;
const lodash_1 = __importStar(require("lodash"));
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const styled_components_1 = __importStar(require("styled-components"));
const common_1 = require("../../../../../common");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const server_1 = require("../../../../../server");
const classes_1 = require("../../../../base/classes");
const MemberHeader_1 = require("./MemberHeader");
const MemberRoleDropDown_1 = require("./MemberRoleDropDown");
const MemberTableStyled = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	gap: 14px;
	align-items: flex-start;
	justify-content: flex-start;
	flex-shrink: 0;
	position: relative;

	.name {
		color: var(--color-black, #101010);
		text-align: left;
		font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--b4-font-size, 14px);
		line-height: var(--b4-line-height, 28px);
		font-weight: var(--b4-font-weight, 400);
		position: relative;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}

	.dropdown {
		width: 100%;
	}

	.body-item {
		position: relative;
	}

	.dropdown-list {
		top: 48px;
	}

	${props => (props.$isMobile ? mobileStyles : desktopStyles)}
`;
const mobileStyles = (0, styled_components_1.css) `
	.table-item-wrap {
		.body-item {
			width: unset;
		}
	}

	.live-list-002 {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		overflow: hidden;
		flex: 1;

		.item {
			border-style: solid;
			border-color: var(--color-grey-c, #e6e8ed);
			border-width: 1px 0px 0px 0px;
			padding: 12px 0px 12px 0px;
			display: flex;
			${props => props.$isDetail
    ? (0, styled_components_1.css) `
							flex-direction: column;
							align-items: flex-start;
					  `
    : (0, styled_components_1.css) `
							flex-direction: row;
							align-items: center;
					  `}

			justify-content: flex-start;
			flex-shrink: 0;

			&:nth-child(1) {
				border-width: 0px;
			}

			p {
				color: var(--color-black, #101010);
				text-align: left;
				font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--b4-font-size, 14px);
				line-height: 150%;
				letter-spacing: -0.02em;
				font-weight: 400;
				text-overflow: ellipsis;
				overflow: hidden;
				white-space: nowrap;
			}

			.grey {
				color: var(--color-grey-l, #83868a);
				font-size: var(--b4-font-size, 12px);
			}
		}
	}
`;
const desktopStyles = (0, styled_components_1.css) `
	min-width: 428px;

	.live-list-002 {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		overflow: hidden;
		flex: 1;

		.table-header {
			background: var(--color-silver, #f3f4f8);
			border-style: solid;
			border-color: var(--color-grey-w, #b6bac0);
			border-width: 1px 0px 0px 0px;
			padding: 10px 16px 10px 16px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;
			align-self: stretch;

			color: var(--color-grey, #666666);
			text-align: left;
			font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b3-font-size, 16px);
			line-height: var(--b3-line-height, 32px);
			font-weight: var(--b3-font-weight, 400);
			position: relative;
			display: flex;
			align-items: center;
			justify-content: flex-start;
		}

		.item {
			padding: 8px 16px 8px 16px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;

			p {
				color: var(--color-black, #101010);
				text-align: left;
				font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--b4-font-size, 14px);
				line-height: var(--b4-line-height, 28px);
				font-weight: var(--b4-font-weight, 400);
				position: relative;
				text-overflow: ellipsis;
				overflow: hidden;
				white-space: nowrap;
			}
		}
	}
`;
// 참여자 표기를 '이름(아이디)' 로 일관화(예: 민지호(05zooooo)).
// nickname 이 사람 이름/아이디로 혼재돼 노출되던 것을 nickname+identifier 조합으로 통일한다.
// 이름이 없거나 아이디와 동일하면 아이디만 노출(중복/괄호만 표기 방지).
const formatMemberLabel = (nickname, identifier) => {
    const name = (nickname || '').trim();
    const id = (identifier || '').trim();
    if (!id)
        return name || '-';
    if (!name || name === id)
        return id;
    return `${name}(${id})`;
};
exports.MembersTable = react_1.default.memo(({ isDetail, isModify, initMember = [], setItem, entryData, }) => {
    const classesId = (0, classes_1.getClassesId)();
    const memberList = (0, react_redux_1.useSelector)((state) => (0, classes_1.getClassesMember)(state), react_redux_1.shallowEqual);
    const { t } = (0, react_i18next_1.useTranslation)();
    // 페이징
    const [page, setPage] = (0, react_1.useState)(0);
    const [previousPage, setPreviousPage] = (0, react_1.useState)(0);
    // 테스트 데이터
    const [testData, setTestData] = (0, react_1.useState)([]);
    // 총 데이터 갯수
    const [totalCount, setTotalCount] = (0, react_1.useState)(0);
    // 체크박스 리스트
    const [checkList, setCheckList] = (0, react_1.useState)([]);
    const [excludeMembers, setExcludeMembers] = (0, react_1.useState)({});
    const [searchOption, setSearchOption] = (0, react_1.useState)({
        type: undefined,
        status: undefined,
        name: undefined,
    });
    // 참가자 목록 가져오기
    const { data, refetch } = (0, server_1.useMemberInfo)({
        ...searchOption,
        class_id: classesId,
        offset: page === 0 ? 0 : page * 10,
        limit: 10,
    });
    // const existMemberIds = useMemo(() => {
    // 	return allChecked ? memberList : initMember.map(i => i.member_id); // 해당 조건을 만족하는 경우에만 user_id 반환
    // }, [initMember, localID, allChecked]);
    const updateList = (0, lodash_1.throttle)(() => {
        // [상세] 참여자 총 명수·리스트·페이징을 이 강의의 members(initMember = conference.members,
        // /conferences?id=...&with_more_info=true 의 members 배열)로 계산한다.
        // /members(class_id 전체 멤버) API 에는 의존하지 않고 로컬 페이지네이션한다.
        if (isDetail) {
            const total = initMember.length;
            const maxPage = Math.max(0, Math.ceil(total / 10) - 1);
            if (page > maxPage && page > 0) {
                setPage(maxPage);
                return;
            }
            const pageMembers = initMember.slice(page * 10, page * 10 + 10);
            const list = pageMembers.map((i) => {
                const memberEntry = (entryData || []).filter(d => d.member_id === i.member_id);
                if (!memberEntry.length || memberEntry[0]?.entry_logs === null) {
                    return {
                        id: i.member_id,
                        user_name: formatMemberLabel(i.nickname, i.identifier),
                        role_name: i.role_name,
                        enter_time: '-',
                        leave_time: '-',
                        total_time: 0,
                    };
                }
                const entryLogs = memberEntry[0].entry_logs;
                let earliestEnterTime = entryLogs[0].enter_time ? (0, moment_1.default)(entryLogs[0].enter_time) : null;
                let latestLeaveTime = entryLogs[0].leave_time ? (0, moment_1.default)(entryLogs[0].leave_time) : null;
                let totalTime = 0;
                entryLogs.forEach(log => {
                    const enterTime = (0, moment_1.default)(log.enter_time);
                    const leaveTime = (0, moment_1.default)(log.leave_time);
                    if (earliestEnterTime === null || enterTime.isBefore(earliestEnterTime))
                        earliestEnterTime = enterTime;
                    if (latestLeaveTime === null || leaveTime.isAfter(latestLeaveTime))
                        latestLeaveTime = leaveTime;
                    totalTime += leaveTime.diff(enterTime, 'minutes');
                });
                return {
                    id: i.member_id,
                    user_name: formatMemberLabel(i.nickname, i.identifier),
                    role_name: i.role_name,
                    enter_time: earliestEnterTime.isValid() ? earliestEnterTime.format('HH:mm') : '-',
                    leave_time: latestLeaveTime.isValid() ? latestLeaveTime.format('HH:mm') : '-',
                    total_time: totalTime,
                };
            });
            setTotalCount(total);
            if (lodash_1.default.isEqual(testData, list))
                return;
            setTestData(list);
            return;
        }
        if (data) {
            const { total_count, found_count, items } = data;
            if (found_count === 0 && page > 0) {
                const maxPage = Math.max(0, Math.ceil(total_count / 10) - 1);
                setPage(maxPage);
                return;
            }
            let list = [];
            if (isModify) {
                list = items.map(i => {
                    const member_data = initMember.find(j => typeof j === 'string' ? j === i.id : j.member_id === i.id);
                    if (!member_data) {
                        return {
                            id: i.id,
                            user_name: formatMemberLabel(i.nickname, i.identifier),
                            role_name: i.level_name === 'member' ? 'participant' : i.level_name,
                            enter_time: undefined,
                            leave_time: undefined,
                            total_time: 0,
                        };
                    }
                    else {
                        return {
                            id: i.id,
                            user_name: formatMemberLabel(member_data.nickname, member_data.identifier),
                            role_name: member_data.role_name,
                            enter_time: undefined,
                            leave_time: undefined,
                            total_time: 0,
                        };
                    }
                });
            }
            else {
                list = items.map(i => {
                    return {
                        id: i.id,
                        user_name: formatMemberLabel(i.nickname, i.identifier),
                        role_name: i.level_name === 'member' ? 'participant' : i.level_name,
                        enter_time: undefined,
                        leave_time: undefined,
                        total_time: 0,
                    };
                });
            }
            setTotalCount(total_count);
            if (lodash_1.default.isEqual(testData, list))
                return;
            setTestData(list);
        }
    }, 1000, { leading: true, trailing: false });
    // useEffect(() => {
    // 	if (!isDetail) setCheckList(excludeMemberIds);
    // }, [excludeMemberIds]);
    (0, react_1.useEffect)(() => {
        setPreviousPage(page);
        if (checkList.length > 0 && previousPage === page) {
            setExcludeMembers(prevState => ({
                ...prevState,
                [page]: checkList,
            }));
        }
    }, [checkList, page]);
    // useEffect(() => {
    // 	setExclude(Object.values(excludeMembers).flat());
    // }, [excludeMembers]);
    // useEffect(() => {
    // 	setExclude(postExcludeMembers);
    // }, [postExcludeMembers]);
    const refetchList = (0, lodash_1.throttle)(refetch, 1000, {
        leading: true,
        trailing: false,
    });
    (0, react_1.useEffect)(() => {
        // 상세 모드는 이 강의의 members(initMember)로 목록/총 명수를 계산하므로 /members API 를 호출하지 않는다.
        if (isDetail)
            return;
        if (!memberList || memberList.length <= 0)
            return;
        refetchList();
    }, [isDetail, memberList, searchOption, classesId, page]);
    (0, react_1.useEffect)(() => {
        updateList();
    }, [data, entryData, initMember, testData, page, isDetail]);
    (0, react_1.useEffect)(() => {
        const list = checkList && checkList.length < 0
            ? testData
            : testData.filter(item => checkList.includes(item.id));
        setItem(list);
    }, [testData, checkList]);
    const handlerMoreData = (page) => {
        setPage(page);
    };
    const { headTitleList, tableReadDataKeys } = react_1.default.useMemo(() => {
        const headTitleList = [
            { title: 'name', space: 2, sort: false },
            { title: 'participant', space: 1, sort: false },
            ...(isDetail
                ? [
                    { title: 'eneter_time', space: 1, sort: false },
                    { title: 'exit_time', space: 1, sort: false },
                    { title: 'progress_time', space: 1, sort: false },
                ]
                : []),
        ];
        const tableReadDataKeys = [
            { title: 'user_name', space: 2, sort: false },
            { title: 'role_name', space: 1, sort: false },
            ...(isDetail
                ? [
                    { title: 'enter_time', space: 1, sort: false },
                    { title: 'leave_time', space: 1, sort: false },
                    { title: 'total_time', space: 1, sort: false },
                ]
                : []),
        ];
        // useMemo에서 반환
        return { headTitleList, tableReadDataKeys };
    }, [isDetail, isModify]);
    // // 상단 레이아웃 검색 조건을 위한 action
    const handlerFilterList = (filter) => setSearchOption(filter);
    const renderTitle = (0, react_1.useMemo)(() => (react_1.default.createElement(MemberHeader_1.MemberHeader, { handlerFilterList: handlerFilterList, isDetail: isDetail, totalTableList: totalCount })), [searchOption, totalCount]);
    const renderItem = (item, styles) => {
        return tableReadDataKeys.map(headItem => isMobile &&
            (headItem.title === 'enter_time' ||
                headItem.title === 'leave_time' ||
                headItem.title === 'total_time') ? null : (react_1.default.createElement("div", { key: headItem.title, className: "body-item", style: {
                flex: (!isMobile || (isMobile && !isDetail)) && headItem.space,
                ...styles?.bodyItem,
            } }, headItem.title === 'role_name' ? (isDetail ? (react_1.default.createElement("p", { className: isMobile ? 'grey' : 'role-name' }, t(`conference.${item[headItem.title]}`))) : (react_1.default.createElement(MemberRoleDropDown_1.MemberRoleDropDown, { isDisable: true, defaultRole: item.role_name, handlerUpdateOption: () => { } }))) : headItem.title === 'total_time' ? (react_1.default.createElement("p", { className: "overText" }, item[headItem.title] === undefined
            ? '-'
            : t('conference.minutes', { minute: item[headItem.title] }))) : (react_1.default.createElement("p", { className: "overText" }, item[headItem.title] || '-')))));
    };
    const { isDesktop, isTablet, isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    return (react_1.default.createElement(MemberTableStyled, { "$isMobile": isMobile, "$isTablet": isTablet, "$isDetail": isDetail, className: "user-list", style: { width: `${isDetail && isDesktop ? '45%' : 'auto'}` } },
        react_1.default.createElement(common_1.Table, { className: "live-list-002", forceShowheader: isMobile ? false : true, showIndex: true, indexOrder: "desc", defaultCheckList: excludeMembers[page] ? excludeMembers[page] : [], isInfinite: false, data: testData, totalCount: totalCount, page: page, sortDefault: "id", pagingCount: 5, headTitleList: headTitleList, renderTitle: renderTitle, renderItem: renderItem, handlerCheckList: setCheckList, handlerMoreData: handlerMoreData, padding: false })));
});
